"use strict";
/**
 * Hailio e-Invoice Kit — portable SARS VAT-Modernisation readiness layer.
 *
 * One dependency-free module, copied into each Hailio app (same pattern as
 * Hailio Pay / Streaks / Push Kit). Apps map their receipt/invoice data to a
 * `SaleInput`, call `buildEInvoice`, and store the structured result. Transmission
 * to the Interoperability Framework stays dormant behind `EINVOICE_ENABLED`
 * until SARS finalises the syntax and the access-point network is live.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.READINESS = exports.emit = exports.isEInvoiceEnabled = exports.DEFAULT_CURRENCY = exports.STANDARD_VAT_RATE = exports.PROFILE_ID = exports.SPEC_ID = exports.KIT_VERSION = exports.EINVOICE_ENABLED = void 0;
__exportStar(require("./model"), exports);
__exportStar(require("./adapter"), exports);
__exportStar(require("./validate"), exports);
__exportStar(require("./accessPoint"), exports);
var config_1 = require("./config");
Object.defineProperty(exports, "EINVOICE_ENABLED", { enumerable: true, get: function () { return config_1.EINVOICE_ENABLED; } });
Object.defineProperty(exports, "KIT_VERSION", { enumerable: true, get: function () { return config_1.KIT_VERSION; } });
Object.defineProperty(exports, "SPEC_ID", { enumerable: true, get: function () { return config_1.SPEC_ID; } });
Object.defineProperty(exports, "PROFILE_ID", { enumerable: true, get: function () { return config_1.PROFILE_ID; } });
Object.defineProperty(exports, "STANDARD_VAT_RATE", { enumerable: true, get: function () { return config_1.STANDARD_VAT_RATE; } });
Object.defineProperty(exports, "DEFAULT_CURRENCY", { enumerable: true, get: function () { return config_1.DEFAULT_CURRENCY; } });
const config_2 = require("./config");
const adapter_1 = require("./adapter");
const validate_1 = require("./validate");
const accessPoint_1 = require("./accessPoint");
/** True only when both the flag is on and a live (non-stub) connector is used. */
function isEInvoiceEnabled() {
    return config_2.EINVOICE_ENABLED;
}
exports.isEInvoiceEnabled = isEInvoiceEnabled;
/**
 * Build + validate an e-invoice and, only if enabled, submit it for clearance.
 * With the default stub connector (or the flag off) this is a pure, side-effect-
 * free build — safe to call in production today.
 */
async function emit(sale, opts, connector = new accessPoint_1.StubAccessPoint()) {
    const invoice = (0, adapter_1.buildEInvoice)(sale, opts);
    const validation = (0, validate_1.validateEInvoice)(invoice);
    let clearance = { status: 'not-live', accessPoint: connector.id };
    if (config_2.EINVOICE_ENABLED && connector.id !== 'stub-not-live' && validation.valid) {
        clearance = await connector.clear(invoice);
        invoice.clearance = {
            status: clearance.status,
            accessPoint: clearance.accessPoint,
            reference: clearance.reference,
            errors: clearance.errors,
            clearedAt: clearance.status === 'cleared' ? new Date().toISOString() : undefined,
        };
    }
    return { invoice, validation, clearance };
}
exports.emit = emit;
/** Machine-readable readiness descriptor — handy for a health/status endpoint. */
exports.READINESS = {
    standard: 'EN16931 (SA CIUS pending SARS Phase 2, 2027/28)',
    model: 'SARS DCTCE 5-corner (e-Invoicing + Interoperability Framework + e-Reporting)',
    capability: 'build+validate+store structured e-invoices; transmission dormant',
    transmitLive: config_2.EINVOICE_ENABLED,
};
